const FOCUSABLE = [
	'a[href]',
	'button:not([disabled])',
	'input:not([disabled]):not([type="hidden"])',
	'textarea:not([disabled])',
	'select:not([disabled])',
	'[tabindex]:not([tabindex="-1"])',
].join(', ');

let lastFocused: HTMLElement | null = null;

export function trapFocus(container: HTMLElement): () => void {
	lastFocused = document.activeElement as HTMLElement;

	const getFocusable = () =>
		Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
			(el) => el.offsetParent !== null,
		);

	// Focus the first focusable element, or the container itself.
	const initial = getFocusable();
	if (initial.length) {
		initial[0].focus();
	} else {
		container.setAttribute('tabindex', '-1');
		container.focus();
	}

	const handler = (e: KeyboardEvent) => {
		if (e.key !== 'Tab') return;

		const focusable = getFocusable();
		if (!focusable.length) return;

		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	};

	container.addEventListener('keydown', handler);

	return () => {
		container.removeEventListener('keydown', handler);
		lastFocused?.focus();
		lastFocused = null;
	};
}
